import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { TransitionProvider } from './contexts/TransitionContext';
import { P5Provider } from './contexts/P5Context';
import NavBar from './components/header/TopNavBar/NavBar';
import PianoNavBar from './components/header/PianoNavBar/PianoNavBar';
import HabbyTitle from './components/header/HabbyTitle/HabbyTitle';
import HomePage from './pages/HomePage/HomePage';
import PosterPage from './pages/PosterPage';
import P5Page from './pages/p5Page/P5Page';
import PareidoliaPage from './pages/PareidoliaPage/PareidoliaPage';
import client from './components/shopify/ApolloClient'; // Ensure this path is correct
import './App.css';
import PareidoliaGenerator from './components/p5/PareidoliaGenerator';
import BlogPage from './pages/BlogPage/BlogPage';
import BlogPostPage from './pages/BlogPage/BlogPostPage';
import BlogAdminPage from './pages/BlogPage/BlogAdminPage';
import BlogEditor from './pages/BlogPage/BlogEditor';
import ButtonPage from './pages/APIPage/ButtonPage';

const AppWrapper = () => {
  return (
    <ApolloProvider client={client}>
      <Router>
        <TransitionProvider>
          <P5Provider>
            <App />
          </P5Provider>
        </TransitionProvider>
      </Router>
    </ApolloProvider>
  );
};
const App = () => {
  const location = useLocation();
  const isPareidoliaPage = location.pathname === '/paredolia';

  return (
    <div className="App">
      {!isPareidoliaPage && <PianoNavBar />}

      <Routes>
        <Route path="/" element={<div><HabbyTitle />  <HomePage /></div>} />
        <Route path="/posters" element={<PosterPage />} />


        <Route path="/paredolia" element={<PareidoliaPage />} />
        <Route path="/art" element={<P5Page />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/post/:postId" element={<BlogPostPage />} />
        <Route path="/blog/admin" element={<BlogAdminPage />} />
        <Route path="/blog/new" element={<BlogEditor />} />
        <Route path="/blog/edit/:postId" element={<BlogEditor />} />
        <Route path="/button" element={<ButtonPage />} />
        {/* Define other routes as needed */}
      </Routes>
    </div>
  );
};

export default AppWrapper;